import React from 'react';
import { Card, Typography } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import AppLayout from '../components/AppLayout';
import ConfigManagement from './admin/ConfigManagement';
import './AdminPanel.css';

const { Title } = Typography;

const AdminConfig = () => {
  return (
    <AppLayout activeMenu="/admin/config">
      <Card className="admin-content-card">
        <div className="admin-content-header">
          <Title level={3} style={{ margin: 0 }}>
            <SettingOutlined style={{ marginRight: 12, color: '#faad14' }} />
            System Configuration
          </Title>
          <p style={{ margin: '8px 0 0 0', color: '#666' }}>
            Configure system settings and preferences
          </p>
        </div>
        <ConfigManagement embedded />
      </Card>
    </AppLayout>
  );
};

export default AdminConfig;
